import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

import { CreateAlertPayload, AlertListItem } from './alert.types';

export const createAlert = async (
  data: CreateAlertPayload,
  options: ServiceRequestConfig = {},
) => {
  return await pilot.post<AlertListItem>('alert/', data, options);
};
